import { trigger, transition, animate, style, state, keyframes, query, stagger } from '@angular/animations';

export const bounceBubbleAnimation = trigger(
  'bounceBubble', [
    state('*', style({
      'transform': 'scale(1)',
    })),
    transition('* => *', [
      animate(800, keyframes([
        style({ transform: "scale(1)", offset: 0 }),
        style({ transform: "scale(1.7)", offset: 0.5 }),
        style({ transform: "scale(0.5)", offset: 0.6 }),
        style({ transform: "scale(1.3)", offset: 0.8 }),
        style({ transform: "scale(1)", offset: 1 })
      ]))
    ])
  ]
);

export const slideToggle = trigger(
  'slideToggle', [
    state('void', style({
      'max-height': 0
    })),
    state('*', style({
      'max-height': '*'
    })),
    transition('void <=> *', [
      animate('.27s ease-out')
    ]),
  ]
);

export const flashAnimation = trigger(
  'flash', [
    state('*', style({
      'opacity': '1',
    })),
    state('void', style({
      'opacity': '0',
    })),
    transition('void => *', [
      animate(300, keyframes([
        style({ opacity: "0", offset: 0 }),
        style({ opacity: "1", offset: 1 })
      ]))
    ]),
    transition('* => void', [
      animate(300, keyframes([
        style({ opacity: "1", offset: 0 }),
        style({ opacity: "0", offset: 1 })
      ]))
    ])
  ]
);

// export const fadeInOut = trigger(
//  'fadeInOut', [
//    state('visible', style({
//      'opacity': '1'
//    })),
//    transition('void => *', [
//      style({
//        'opacity': 0
//      }),
//      animate('.7s ease-out')
//    ]),
//    transition('* => void', [
//      animate(350, style({
//        'opacity': 0
//      }))
//    ])
//  ]
// );

// export const showMoreLess = trigger(
//  'showMoreLess', [
//    state('less', style({ height: '48px' })),
//    state('more', style({ height: '*' })),
//    transition('less => more', [
//      style({ height: '48px' }),
//      animate(350, style({ height: '*' }))
//    ]),
//    transition('more => less', [
//      animate(350, style({ height: '48px' }))
//    ])
//  ]
// );
